import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { Group } from './group';

export class GroupStateModel extends EntityStateModel<Group> {}
